import { api } from './BaseApi'
import {
  IUpdatePlanMenuCloseDto,
  IPlanMenuCloseDimensionDto,
} from './dto/PlanMenuCloseDto'

export const planMenuCloseDimensionApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getPlanCloseDimensionByOrderLine: builder.query<
      IPlanMenuCloseDimensionDto[],
      { orderLineId: number }
    >({
      query: ({ orderLineId }) => ({
        url: `/plan_menu_close_dimension/order_line/${orderLineId}/`,
      }),
      providesTags: ['PlanMenuControl'],
    }),
    getPlanMenuCloseDimension: builder.query<
      IPlanMenuCloseDimensionDto,
      { id: number }
    >({
      query: ({ id }) => ({
        url: `/plan_menu_close_dimension/${id}/`,
      }),
      providesTags: ['PlanMenuControl'],
    }),
    updatePlanMenuCloseDimension: builder.mutation<
      IPlanMenuCloseDimensionDto,
      { id: number; data: IUpdatePlanMenuCloseDto }
    >({
      query: ({ id, data }) => ({
        method: 'PATCH',
        url: `/plan_menu_close_dimension/${id}/`,
        body: data,
      }),
      invalidatesTags: ['PlanMenuControl'],
    }),
    updatePlanMenuCloseDimensionByOrderLine: builder.mutation<
      IPlanMenuCloseDimensionDto[],
      { orderLineId: number; data: IUpdatePlanMenuCloseDto }
    >({
      query: ({ orderLineId, data }) => ({
        method: 'PATCH',
        url: `/plan_menu_close_dimension/order_line/${orderLineId}/`,
        body: data,
      }),
      invalidatesTags: ['PlanMenuControl'],
    }),
  }),
})

export const {
  useGetPlanCloseDimensionByOrderLineQuery,
  useGetPlanMenuCloseDimensionQuery,
  useUpdatePlanMenuCloseDimensionMutation,
  useUpdatePlanMenuCloseDimensionByOrderLineMutation,
} = planMenuCloseDimensionApi
